import React ,{ useState, useEffect ,useRef}  from "react";
import { Button,Avatar ,Row,Col} from "antd";
import CapillarLogo from "../../../assets/img/png/Logo_color.png";
import NoAvatar from "../../../assets/img/png/no-avatar.png";
import {
  MenuUnfoldOutlined,
  LogoutOutlined,
  CloseOutlined,
  UserOutlined,
  SettingOutlined
} from "@ant-design/icons";
import "./MenuTop.scss";
import { logout } from "../../../api/auth";
import { get } from "../../../api/get";
import {useResults} from "../../../hooks"
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'react-modern-modal';



export default function MenuTop(props) {
  const { menuCollapsed, setMenuCollapsed, usuario } = props;
  const{isoutput,setisoutput}=useResults();
  const [user,setuser] = useState([]);
  const [avatar,setAvatar] = useState('');

  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  useEffect(() => {
    get('user','user','').then((response)=>{
      // console.log('response:')
      // console.log(response.user)
      setuser(response.user)
      setAvatar(response.user.avatar)
    })
  }, [isOpen, setIsOpen]); 

  const location = window.location.href;
  const loc=location.split('id=')
  const showButton = location.includes('graph');
  const isOutput = location.includes('graphOUTPUTS');
  const isInput = location.includes('graphINPUTS');
  const isComparison = location.includes('graph-mult');
  // console.log(isoutput,'00')

  const logoutUser = () => {
    logout();
    window.location.reload();
  };

  function change(isINPUT,isCompa){
   if(isCompa){
      window.location.href =  `/admin/graph-mult?id=${loc[1]}`;
    }else if(!isINPUT){
      window.location.href =  `/admin/graphOUTPUTS?id=${loc[1]}`;
    }else if(isINPUT){
      window.location.href =  `/admin/graphINPUTS?id=${loc[1]}`;
    }
  }

  //console.log(eori);
  return (
    <div className="menu-top">
      <div className="menu-top__left">
        <img
          className="menu-top__left-logo"
          src={CapillarLogo}
          alt="Capillar IT"
          onClick={()=>window.location.href = "/admin"}
        />
        <div className="menu-top__menu">
          <Button type="link" onClick={() => setMenuCollapsed(!menuCollapsed)}>
            {menuCollapsed ? <MenuUnfoldOutlined style={{color:'rgb(0,104,178)',fontSize:'22px'}}/> : <CloseOutlined style={{fontSize:'22px'}}/>}
            {/* {menuCollapsed ? <MenuUnfoldOutlined style={{color:'rgb(0,104,178)',fontSize:'22px'}}/> : <CloseOutlined style={{fontSize:'22px'}}/>} */}
          </Button>
        </div>
      </div>
      <p className="menu-top__username">{usuario}</p>

      <div>
        <div className="menu-top__right3">
        {(showButton)?
          (isComparison===false)
            ?<Button type="link" onClick={()=>change(true,true)}><p className="menu-top__usernames">COMPARISON</p></Button>
            :<Button type="link" onClick={()=>change(true,true)}><p className="menu-top__usernames_blue">COMPARISON</p></Button>
        :<p></p>}
        </div>
        <div className="menu-top__right2">
        {(showButton)?
          (isInput===false)
            ?<Button type="link" onClick={()=>change(true,false)}><p className="menu-top__usernames">INPUTS</p></Button>
            :<Button type="link" onClick={()=>change(true,false)}><p className="menu-top__usernames_blue">INPUTS</p></Button>
        :<p></p>}
        </div>
        <div className="menu-top__right1">
        {(showButton)?
          (isOutput===false)
            ?<Button type="link" onClick={()=>change(false,false)}><p className="menu-top__usernames">OUTPUTS</p></Button>
            :<Button type="link" onClick={()=>change(false,false)}><p className="menu-top__usernames_blue">OUTPUTS</p></Button>
        :<p></p>}
        </div>
        <div className="menu-top__right">
          <Button type="link" onClick={handleOpen}>
          {/* <Button type="link" onClick={logoutUser}> */}
            <SettingOutlined style={{color:'rgb(0,104,178)',fontSize:'22px'}}/>
            {/* <LogoutOutlined style={{color:'rgb(0,104,178)',fontSize:'22px'}}/> */}
          </Button>
        </div>
      </div>
      <Modal isOpen={isOpen} onClose={handleClose}>
        {/* <ModalHeader>{usuario}</ModalHeader> */}
        <div>
          <Row style={{alignItems:'end',justifyContent:'space-around'}}>
            <Avatar style={{marginTop:'10px',border: '3px solid rgb(0,104,178)'}} size={150} src={(avatar)?avatar:NoAvatar} />
            {/* <Avatar style={{marginTop:'10px',border: '3px solid rgb(0,104,178)'}} size={150} src={(avatar.length>2)?avatar:NoAvatar} /> */}

            <div>
              <div style={{
                minHeigth:'50px !important',
              color:'rgb(0,0,0)',
              fontFamily:'report-bold' ,
              fontSize:'25px',}}>{usuario}</div>
              <div style={{
                marginBottom:'0px',
              color:'rgb(0,0,0)',
              fontFamily:'report' ,
              fontSize:'20px',}}>{user.name} {user.lastname}</div>
              
            </div>

          </Row>

          {/* <Avatar src={avatar ? avatar : NoAvatar} /> */}
        </div>
        <ModalFooter style={{justifyContent:'space-between'}}>
          <Button type="link" onClick={handleClose} style={{
            borderColor: "rgb(255,0,0)",
            backgroundColor: "rgb(255,157,157)" ,
            color:'rgb(200,0,0)',
            fontFamily:'report',
            fontSize:'17px',
            marginTop:'10px'}}>
          {/* <Button type="link" onClick={logoutUser}> */}
            Cancel
          </Button>
          <Button type="link" onClick={()=>window.location.href='/admin/Profile'} style={{
            borderColor: "rgb(0,104,178)",
            backgroundColor: "rgb(203,234,247)" ,
            color:'rgb(0,104,178)',
            fontFamily:'report',
            fontSize:'17px',
            marginTop:'10px'}}>
          {/* <Button type="link" onClick={logoutUser}> */}
              <UserOutlined style={{color:'rgb(0,104,178)',fontSize:'17px'}}/>
            Profile
          </Button>
         
          <Button type="link" onClick={logoutUser} style={{
            borderColor: "rgb(0,104,178)",
            backgroundColor: "rgb(203,234,247)" ,
            color:'rgb(0,104,178)',
            fontFamily:'report',
            fontSize:'17px',
            marginTop:'10px'}}>
          {/* <Button type="link" onClick={logoutUser}> */}
              <LogoutOutlined style={{color:'rgb(0,104,178)',fontSize:'17px'}}/>
            Close Session
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
